// extracted by mini-css-extract-plugin
export default {"overlay":"overlay___QENzQ","qtySelector":"qtySelector___ehYhU","frap":"frap___kOgCf"};